export enum Card {
  NextCommitmentsCard = 'NextCommitmentsCard',
  ReminderCard = 'ReminderCard',
  FromYourAccountCard = 'FromYourAccountCard',
  ActivitiesSummaryCard = 'ActivitiesSummaryCard',
  OrdersToProcessCard = 'OrdersToProcessCard',
  TasksToCompleteCard = 'TasksToCompleteCard',
  TicketsSummaryCard = 'TicketsSummaryCard',
  AnalysisToCompleteCard = 'AnalysisToCompleteCard',
}
